import { useInstantSearch } from 'react-instantsearch';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { FilterTitle } from '@sorare/core/src/components/search/FilterTitle';
import {
  FILTERS,
  FilterWidget,
  TOGGLE_FILTERS,
} from '@sorare/core/src/lib/filters';
import { powerAlgorithm } from '@sorare/core/src/lib/slider';

import { RangeSlider } from 'search/RangeSlider';
import { makeRangeFilter } from 'searchCards/RangeSlider';

import { jerseySerialWidget } from './RefineJerseySerial';

const FILTER = FILTERS.serialNumber;

const refineSerialNumberAlgorithm = powerAlgorithm({ power: 2 });

const SerialNumberRoot = styled(Vertical).attrs({ gap: 2 })``;

const SerialNumberTitle = () => {
  const { indexUiState } = useInstantSearch();

  const selected =
    !!indexUiState.range?.[FILTER.attribute] ||
    !!indexUiState.toggle?.[TOGGLE_FILTERS.jerseySerialFilter.attribute];

  return <FilterTitle name={FILTER.title} selected={selected} />;
};

export const RefineSerialNumber: FilterWidget = {
  ...makeRangeFilter(({ visible }) => {
    return (
      <SerialNumberRoot>
        <RangeSlider
          attribute={FILTERS.serialNumber.attribute}
          algorithm={refineSerialNumberAlgorithm}
          toInput={(value: number) => Math.round(value).toString()}
          visible={visible}
        />
        {jerseySerialWidget.Component({ visible })}
      </SerialNumberRoot>
    );
  }, FILTERS.serialNumber),
  title: <SerialNumberTitle />,
};
